<script setup>
import { computed } from 'vue';
import { addDays, startOfWeek } from 'date-fns';
import { useLocale } from 'shared/composables/useLocale';

const { resolvedLocale } = useLocale();

const calendarWeeks = computed(() => {
  const monday = startOfWeek(new Date(), { weekStartsOn: 1 });

  return Array.from({ length: 7 }, (_, index) => ({
    id: index + 1,
    label: new Intl.DateTimeFormat(resolvedLocale.value, {
      weekday: 'narrow',
    }).format(addDays(monday, index)),
  }));
});
</script>

<template>
  <div class="max-w-md mx-auto grid grid-cols-7 gap-2">
    <div
      v-for="day in calendarWeeks"
      :key="day.id"
      class="flex items-center justify-center font-medium text-sm w-9 h-7 py-1.5 px-2"
    >
      {{ day.label }}
    </div>
  </div>
</template>
